import { render, staticRenderFns } from "./product_management.vue?vue&type=template&id=02cf52e6&scoped=true"
import script from "./product_management.vue?vue&type=script&lang=js"
export * from "./product_management.vue?vue&type=script&lang=js"
import style0 from "./product_management.vue?vue&type=style&index=0&id=02cf52e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02cf52e6",
  null
  
)

export default component.exports